/**
 * Freshness and format (§7.3, §7.5). These requirements are about the
 * evidence rather than the facts, so in phase 1 they carry the specification
 * — window, format rules, and whether a stale item can be re-dated or must
 * be re-collected (FR-6) — and report PENDING_EVIDENCE until documents exist
 * to check. The freshness ENGINE that computes FRESH/EXPIRING/STALE against a
 * moving submission date is phase 3 (FR-1 – FR-9); this is the ruleset half
 * it will read.
 */
import type { EvaluatePredicate } from "./predicate.js";

export const evidence_specification_only: EvaluatePredicate = (_facts, rule, ctx) => {
  const windowDays = rule.params?.["window_days_figure"]
    ? ctx.paramFigure(rule, "window_days_figure")
    : null;

  return {
    status: "PENDING_EVIDENCE",
    ...(typeof windowDays === "number" ? { figures: { window_days: windowDays } } : {}),
    notes: [
      "This is checked against the documents themselves, which this calculation does not collect.",
    ],
  };
};
